import { Field } from "aderant-conflicts-models";
import { AderantTheme } from "@aderant/aderant-react-components";
import React, { CSSProperties } from "react";
import { conflictsPalette } from "styles/conflictsPalette";
import { StyledFieldOverrides } from "../DynamicFields/DisplayFields/commonStyles";
import { BooleanInformation } from "../DynamicFields/DisplayFields/BooleanInformation";
import { CurrencyInformation } from "../DynamicFields/DisplayFields/CurrencyInformation";
import { CustomInformation } from "../DynamicFields/DisplayFields/CustomInformation";
import { DateInformation } from "../DynamicFields/DisplayFields/DateInformation";
import { HighlightStringInformation } from "../DynamicFields/DisplayFields/HighlightStringInformation";
import { StringInformation } from "../DynamicFields/DisplayFields/StringInformation";
import { UserInformation } from "../DynamicFields/DisplayFields/UserInformation";
import { styles as fieldStyles } from "../DynamicFields/DisplayFields/commonStyles";
import { assertUnreachable } from "@aderant/aderant-web-fw-core";
import { NumberInformation } from "../DynamicFields/DisplayFields/NumberInformation";

const sectionHeading: CSSProperties = {
    margin: "0 0 16px 0",
    fontWeight: 700,
    padding: "0 16px",
    fontSize: AderantTheme.typography.pxToRem(14)
};
const flyoutSection: CSSProperties = {
    backgroundColor: conflictsPalette.background.white,
    boxShadow: "0 2px 4px rgb(0 0 0 / 15%)",
    padding: "16px 0",
    borderRadius: "8px",
};
export interface TileProps {
    title: string;
    fields?: (Field & StyledFieldOverrides)[];
    styles?: React.CSSProperties;
}

export const Tile = (props: TileProps): JSX.Element => {
    const { title, fields, styles } = props;

    const renderComponents = (): React.ReactNode[] | null => {
        if (!fields || fields.length === 0) {
            return null;
        }
        const renderNodes = fields.map((field, index) => {
            let node: React.ReactNode;
            switch (field.displayFormat) {
                case "Boolean":
                    node = <BooleanInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "Currency":
                    node = <CurrencyInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "Date":
                case "DateTime":
                    node = <DateInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "String":
                    node = <StringInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "Number":
                    node = <NumberInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "User":
                case "UserWithAvatar":
                    node = <UserInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "Custom":
                    node = <CustomInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                case "Highlight":
                    node = <HighlightStringInformation key={`${field.fieldLabel}-${index}`} field={field} />;
                    break;
                default:
                    assertUnreachable(field);
            }
            return (
                <div key={`${field.fieldLabel}-${index}`} style={{ ...fieldStyles.containerStyle, ...field.containerStyle }}>
                    {node}
                </div>
            );
        });
        return renderNodes;
    };

    return (
        <div style={{ ...flyoutSection, ...styles, display: "flex", flexDirection: "column" }} aria-label={`${title}`}>
            <h3 style={{ ...sectionHeading }}>{title}</h3>
            <hr style={{ borderWidth: 0, borderStyle: "solid", borderColor: conflictsPalette.divider, borderBottomWidth: "thin", margin: "0 0 7px 0" }} />
            <div style={{ flex: "1 1 auto", padding: "0 16px" }}>
                {renderComponents()}
            </div>
        </div>
    );
};
